import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 25000,
});

// ---------- Retry interceptor (cold-start resilience) ----------
// Retries failed GET requests up to 2 times on 5xx, timeouts, or network errors.
// Exponential backoff: 500ms, then 1500ms. Skips non-idempotent verbs by default.
const RETRY_LIMIT = 2;
const RETRY_BASE_MS = 500;
const RETRY_METHODS = new Set(["get", "head", "options"]);

const shouldRetry = (error) => {
  if (!error.config) return false;
  const cfg = error.config;
  const method = (cfg.method || "get").toLowerCase();
  // Allow opt-in retry for POSTs that pass { retry: true } in the request config.
  if (!RETRY_METHODS.has(method) && !cfg.retry) return false;
  // Network error / timeout
  if (!error.response) return true;
  // Server side 5xx — likely a cold pod or transient failure
  const s = error.response.status;
  return s >= 500 && s <= 599;
};

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (!cfg) return Promise.reject(error);
    cfg.__retryCount = cfg.__retryCount || 0;
    if (cfg.__retryCount >= RETRY_LIMIT || !shouldRetry(error)) {
      return Promise.reject(error);
    }
    cfg.__retryCount += 1;
    const delay = RETRY_BASE_MS * Math.pow(3, cfg.__retryCount - 1);
    await sleep(delay);
    return api(cfg);
  }
);

export function setToken(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("wf_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("wf_token");
  }
}

const saved = typeof window !== "undefined" ? localStorage.getItem("wf_token") : null;
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;
